import React from 'react';
import Config from "../../config/Configs"
import {sendGAEvent} from "../../utils/utils"
const BookItem = ({book, language}) => {
    const {title, cover} = book;
    const {viewSample, buyNow} = language;
    const onViewSample = ()=>{
        
        sendGAEvent({category:"View Sample", action:"click", label:book.isbn})
        window.open(Config.launchBookUrlBase + book.isbn, "_blank")
    }
    const onBuyClick=()=>{
        sendGAEvent({category:"View Series", action:"click", label:book.isbn})
        window.open(book.bookmeta.seriesURL, "_blank")
    }
    return (
        <div className="book-each">
            <div className="book-image">
                <img src={cover} alt={title} />
            </div>
            <div className="book-action-buttons">
                <button onClick={onViewSample} type="button" className="view-sample-button">{viewSample}</button>
                <button onClick={onBuyClick} type="button" className="buy-now-button">{buyNow}</button>
            </div>
        </div>
    )
}
export default (BookItem)
